<template>
  <div class="modal-overlay">
    <div class="create-campaign">
      <div class="section-header">
        <h3>{{ editCampaign.id ? 'EDIT: ' : 'CREATE: ' }} CAMPAIGN</h3>
        <i class="fas fa-times" @click="closeModal()"></i>
      </div>
      <div class="section-body">
        <div class="campign-attribute">
          <label>Title</label>
          <input type="text" v-model="title" />
        </div>
        <div class="campign-attribute">
          <label>Ad Location</label>
          <select>
            <option>All Locations</option>
          </select>
        </div>
        <div class="buttons">
          <button class="secondary-btn-dark" @click="closeModal()">
            CANCEL
          </button>
          <button @click="save()" class="primary-btn">
            SAVE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateCampaign, createCampaign } from "@/api/requests";

export default {
  name: "CampaignEditModal",

  data() {
    return {
      title: '',
    }
  },

  mounted() {
    if (this.editCampaign.id) {
      this.title = this.editCampaign.title;
    }
  },

  methods: {
    closeModal() {
      this.$store.dispatch('campaigns/closeCampaignPrompt');
    },

    save() {
      let payload = {
        title: this.title,
      };

      if (this.editCampaign.id) {
        // ID exists, we are editing
        updateCampaign(this.editCampaign.id, payload).then((response) => {
          if (response.data.image) {
            payload['image'] = response.data.image;
          }
          this.$store.commit('campaigns/updateCampaign', payload);
          this.$toasted.global.app_success({
            message: "Campaign has been updated."
          });
          this.closeModal();
        });
      } else {
        // No ID, we are creating
        createCampaign(payload).then((response) => {
          payload['id'] = response.data.id;
          this.$store.commit('campaigns/addCampaign', payload);
          this.$toasted.global.app_success({
            message: "Campaign has been created."
          });
          this.closeModal();
        });
      }
    },
  },

  computed: {
    editCampaign() {
      return this.$store.state.campaigns.editCampaign;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";
@import "@/assets/css/internal";

.modal-overlay {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.50);
  z-index: 100;
  left: 0;

  .create-campaign {
    background: $sec1; 
    width: 30%;
    margin-left: 40%;
    margin-top: 150px;
    box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.55);

    .section-header {
      background: $sec0; 
      padding: $spacing-base;
      display: flex;
      align-items: center;

      i {
        color: $sec6;
        cursor: pointer;
      }
    }

    .section-body {
      padding: $spacing-base;

      .campign-attribute {
        margin-bottom: $spacing-base;
        label {
          display: block;
          color: $sec7;
          font-size: $font-size-base;
          font-weight: 500;
          margin-bottom: $spacing-small/2;
        }
      }
    }

    h3 {
      margin: 0;
      padding: 0;
      color: $sec6;
      text-transform: uppercase;
      flex: 1
    }

    input {
      background: $dark;
      color: $sec2;
      width: 100%;
      box-sizing: border-box;
    }

    select {
      background-color: $dark;
      color: $sec2;
      width: 50%;
    }
  }
}

.default {
  float: left;
  .default-img {
    width: 20px;
    height: 20px;
    border-radius: 200px;
    padding: 30px;
    background: $dark;
  }
}

</style>